import { MODELS_LIST } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

export const INITIAL_STATE = {
  models: [],
  downloadUrl: null,
  fetchModelsStatus: null,
  fetchModelsError: null,
  selectedModelIds: [],
  gridState: {
    actuarial: {
      sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
    },
    classifier: {
      sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
    },
  },
  controlledGridState: {
    actuarial: {
      sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
    },
    classifier: {
      sortBy: [{ id: 'created', desc: true, find: () => {}, findIndex: () => {} }],
    },
  },
  selectedGridRows: {
    actuarial: [],
    classifier: [],
  },
  maxGridRowSelection: {
    classifier: 3,
    actuarial: 3,
  },
  editModelStatus: null,
  deleteModelStatus: null,
  checkDeleteModelStatus: null,
  checkDeleteModelError: null,
  checkDeleteModelDependents: [],
  approveModelStatus: null,
  hideModelStatus: null,
  hideModelError: null,
  showModelStatus: null,
  showModelError: null,
  client: null,
  fetchClientByTenantStatus: null,
  fetchClientByTenantError: null,
  fetchModelDownloadStatus: null,
  fetchModelDownloadError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODELS_LIST.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case MODELS_LIST.FETCH_CLIENT_BY_TENANT:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.FETCH_CLIENT_BY_TENANT_SUCCEEDED:
      return {
        ...state,
        client: action.payload,
        fetchClientByTenantStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.FETCH_CLIENT_BY_TENANT_FAILED:
      return {
        ...state,
        fetchClientByTenantStatus: CONSTANTS.API.FAILED,
        fetchClientByTenantError: action.payload,
      };
    case MODELS_LIST.FETCH_MODELS:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.FETCH_MODELS_SUCCEEDED:
      return {
        ...state,
        models: action.payload,
        fetchModelsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.FETCH_MODELS_FAILED:
      return {
        ...state,
        fetchModelsStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_LIST.FETCH_MODEL_DL_SUCCEEDED:
      return {
        ...state,
        fetchModelDownloadStatus: CONSTANTS.API.SUCCEEDED,
        downloadUrl: action.payload,
      };
    case MODELS_LIST.FETCH_MODEL_DL_FAILED:
      return {
        ...state,
        fetchModelDownloadStatus: CONSTANTS.API.FAILED,
        fetchModelDownloadError: action.payload,
      };
    case MODELS_LIST.SET_GRID_STATE:
      return {
        ...state,
        gridState: {
          ...state.gridState,
          [action.payload.type]: action.payload.payload,
        },
      };
    case MODELS_LIST.SET_SELECTED_GRID_ROWS:
      return {
        ...state,
        selectedGridRows: {
          ...state.selectedGridRows,
          [action.payload.type]: action.payload.payload,
        },
        selectedModelIds: Object.values({
          ...state.selectedGridRows,
          [action.payload.type]: action.payload.payload,
        })
          .flat()
          .map(({ original: { id } }) => id),
        gridState: {
          ...state.gridState,
          [action.payload.type]: {
            ...state.gridState[action.payload.type],
            selectedRowIds: Object.fromEntries(action.payload.payload.map(({ id }) => [id, true])),
          },
        },
        controlledGridState: {
          ...state.controlledGridState,
          [action.payload.type]: {
            selectedRowIds: Object.fromEntries(action.payload.payload.map(({ id }) => [id, true])),
          },
        },
      };
    case MODELS_LIST.DESELECT_ALL_MODEL_IDS:
      return {
        ...state,
        controlledGridState: {
          classifier: { selectedRowIds: {} },
          actuarial: { selectedRowIds: {} },
        },
        selectedGridRows: {
          classifier: [],
          actuarial: [],
        },
        selectedModelIds: [],
      };
    case MODELS_LIST.DESELECT_ALL_MODEL_IDS_BY_TYPE:
      return {
        ...state,
        controlledGridState: {
          ...state.controlledGridState,
          [action.payload]: { selectedRowIds: {} },
        },
        selectedGridRows: {
          ...state.selectedGridRows,
          [action.payload]: [],
        },
        selectedModelIds: [],
      };
    case MODELS_LIST.EDIT_MODEL:
      return {
        ...state,
        editModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.EDIT_MODEL_SUCCEEDED:
      return {
        ...state,
        models: state.models.map((model) =>
          model.id === action.payload.id ? { ...model, ...action.payload.payload } : model
        ),
        editModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.EDIT_MODEL_FAILED:
      return {
        ...state,
        editModelStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_LIST.DELETE_MODEL:
      return {
        ...state,
        deleteModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.DELETE_MODEL_SUCCEEDED:
      return {
        ...state,
        models: state.models.filter(({ id }) => id !== action.payload),
        deleteModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.DELETE_MODEL_FAILED:
      return {
        ...state,
        deleteModelStatus: CONSTANTS.API.FAILED,
      };
    case MODELS_LIST.CHECK_DELETE_MODEL:
      return {
        ...state,
        checkDeleteModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.CHECK_DELETE_MODEL_SUCCEEDED:
      return {
        ...state,
        checkDeleteModelDependents: action.payload,
        checkDeleteModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.CHECK_DELETE_MODEL_FAILED:
      return {
        ...state,
        checkDeleteModelStatus: CONSTANTS.API.FAILED,
        checkDeleteModelError: action.payload,
      };
    case MODELS_LIST.HIDE_MODEL:
      return {
        ...state,
        hideModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.HIDE_MODEL_SUCCEEDED:
      return {
        ...state,
        hideModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.HIDE_MODEL_FAILED:
      return {
        ...state,
        hideModelStatus: CONSTANTS.API.FAILED,
        hideModelError: action.payload,
      };
    case MODELS_LIST.COPY_MODEL:
      return {
        ...state,
        copyModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.COPY_MODEL_SUCCEEDED:
      return {
        ...state,
        copyModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.COPY_MODEL_FAILED:
      return {
        ...state,
        copyModelStatus: CONSTANTS.API.FAILED,
        copyModelError: action.payload,
      };
    case MODELS_LIST.SHOW_MODEL:
      return {
        ...state,
        showModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.SHOW_MODEL_SUCCEEDED:
      return {
        ...state,
        showModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.SHOW_MODEL_FAILED:
      return {
        ...state,
        showModelStatus: CONSTANTS.API.FAILED,
        showModelError: action.payload,
      };
    case MODELS_LIST.APPROVE_MODEL:
      return {
        ...state,
        approveModelStatus: CONSTANTS.API.STARTED,
      };
    case MODELS_LIST.APPROVE_MODEL_SUCCEEDED:
      return {
        ...state,
        approveModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODELS_LIST.APPROVE_MODEL_FAILED:
      return {
        ...state,
        approveModelStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
